"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _EmptyPage = _interopRequireDefault(require("../../preact-components/empty-page/EmptyPage"));

var _header = _interopRequireDefault(require("../header"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _buttonControl = _interopRequireDefault(require("../../preact-components/button-control"));

var _Table = _interopRequireDefault(require("../../preact-components/table/Table"));

var _BadgeActions = _interopRequireDefault(require("../../preact-components/badges/BadgeActions"));

var _ConfirmationModal = _interopRequireDefault(require("@insided/shared/uikit/Modal/ConfirmationModal"));

var _axios = _interopRequireDefault(require("axios"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BadgeOverview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(BadgeOverview, _Component);

  var _super = _createSuper(BadgeOverview);

  function BadgeOverview(props) {
    var _this;

    (0, _classCallCheck2.default)(this, BadgeOverview);
    _this = _super.call(this, props);
    _this.state = {
      confirmationModelOpen: false,
      badges: props.badges
    };
    _this.deleteBadge = _this.deleteBadge.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCancelDelete = _this.onCancelDelete.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickDelete = _this.onClickDelete.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BadgeOverview, [{
    key: "getColumns",
    value: function getColumns() {
      var _this2 = this;

      return [{
        header: 'Icon',
        accessor: 'image',
        size: 'xs',
        cell: function cell(_ref) {
          var imageSource = _ref.imageSource;
          return (0, _preact.h)("img", {
            width: 64,
            src: (0, _absoluteUrlRuntime.resolveUrl)("".concat(imageSource))
          });
        }
      }, {
        header: 'Name',
        accessor: 'title',
        size: 's',
        cell: this.props.canUserEditBadges ? function (_ref2) {
          var title = _ref2.title,
              id = _ref2.id;
          return (0, _preact.h)("a", {
            href: (0, _absoluteUrlRuntime.resolveUrl)("/settings/badge/edit/".concat(id))
          }, title);
        } : function (_ref3) {
          var title = _ref3.title;
          return title;
        }
      }, {
        header: 'Description',
        accessor: 'description',
        size: 's'
      }, {
        header: 'Badge type',
        accessor: 'manual',
        size: 'xs',
        cell: function cell(_ref4) {
          var active = _ref4.active;
          return active ? 'Automatic' : 'Manual';
        }
      }, {
        header: 'Rewarded users',
        accessor: 'rewardedUsers',
        size: 'right'
      }].concat((0, _toConsumableArray2.default)(this.props.canUserEditBadges ? [{
        header: 'Actions',
        accessor: 'id',
        size: 'custom',
        cell: function cell(_ref5) {
          var title = _ref5.title,
              id = _ref5.id;
          return (0, _preact.h)(_BadgeActions.default, {
            id: id,
            title: title,
            onDelete: _this2.onClickDelete
          });
        }
      }] : []));
    }
  }, {
    key: "deleteBadge",
    value: function () {
      var _deleteBadge = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this$state$badgeToBe, _this$state$badgeToBe2, badgeId, title, badgeList;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                badgeId = (_this$state$badgeToBe = this.state.badgeToBeDeleted) === null || _this$state$badgeToBe === void 0 ? void 0 : _this$state$badgeToBe.id;
                title = ((_this$state$badgeToBe2 = this.state.badgeToBeDeleted) === null || _this$state$badgeToBe2 === void 0 ? void 0 : _this$state$badgeToBe2.title) || '';

                if (!(typeof badgeId === 'undefined')) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                badgeList = this.state.badges;
                _context.next = 8;
                return _axios.default.delete('/settings/badge/delete/' + badgeId.toString());

              case 8:
                this.setState({
                  confirmationModelOpen: false,
                  badges: badgeList.filter(function (badge) {
                    return badge.id !== badgeId;
                  }),
                  messageType: 'success',
                  message: "You've deleted the '".concat(title, "' badge. It can take up to an hour for the badge to be fully removed from the community")
                });
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                this.setState({
                  confirmationModelOpen: false,
                  messageType: 'error',
                  message: 'Sorry something went wrong please try again.'
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function deleteBadge() {
        return _deleteBadge.apply(this, arguments);
      }

      return deleteBadge;
    }()
  }, {
    key: "onCancelDelete",
    value: function onCancelDelete() {
      this.setState({
        confirmationModelOpen: false
      });
    }
  }, {
    key: "onClickDelete",
    value: function onClickDelete(id, title) {
      this.setState({
        confirmationModelOpen: true,
        badgeToBeDeleted: {
          id: id,
          title: title
        },
        messageType: undefined
      });
    }
  }, {
    key: "render",
    value: function render() {
      var canUserAddBadges = this.props.canUserAddBadges;
      var _this$state = this.state,
          badges = _this$state.badges,
          confirmationModelOpen = _this$state.confirmationModelOpen,
          badgeToBeDeleted = _this$state.badgeToBeDeleted,
          message = _this$state.message,
          messageType = _this$state.messageType;
      var title = (badgeToBeDeleted === null || badgeToBeDeleted === void 0 ? void 0 : badgeToBeDeleted.title) || '';
      var isVisibleFor = messageType === 'success' ? 5000 : false;
      return (0, _preact.h)("div", null, messageType && (0, _preact.h)(_AlertComponent.default, {
        messageType: messageType,
        message: message,
        sticky: true,
        isVisibleFor: isVisibleFor
      }), (0, _preact.h)(_header.default, {
        title: "Badges",
        disableCancelButton: true,
        disableSaveButton: true,
        customButtons: badges.length ? [(0, _preact.h)(_buttonControl.default, {
          class: "qa-award-badge",
          newStyle: true,
          title: "Award badge",
          size: "medium",
          onClick: function onClick() {
            return window.location.assign((0, _absoluteUrlRuntime.resolveUrl)('/settings/badge/award'));
          },
          key: "award-badge"
        })].concat((0, _toConsumableArray2.default)(canUserAddBadges ? [(0, _preact.h)(_buttonControl.default, {
          class: "qa-add-badge",
          newStyle: true,
          variant: "brand",
          title: "Add badge",
          size: "medium",
          onClick: function onClick() {
            return window.location.assign((0, _absoluteUrlRuntime.resolveUrl)('/settings/badge/add'));
          },
          key: "add-badge"
        })] : [])) : undefined
      }), badges.length ? (0, _preact.h)(_Table.default, {
        model: this.getColumns(),
        rows: badges
      }) : (0, _preact.h)(_EmptyPage.default, {
        img_src: "".concat((0, _globals.default)('basePath'), "images/empty_badge.png"),
        header: "Create your first badge",
        text: "Engage your community by awarding members with badges.",
        button: canUserAddBadges ? {
          link: '/settings/badge/add',
          text: 'Add badge'
        } : undefined
      }), window.location.search === '?badgeAwarded' && (0, _preact.h)(_AlertComponent.default, {
        messageType: "success",
        message: "Badge has been successfully awarded",
        sticky: true,
        isVisibleFor: 3000
      }), (0, _preact.h)(_ConfirmationModal.default, {
        isOpen: confirmationModelOpen,
        handleConfirmation: this.deleteBadge,
        onClose: this.onCancelDelete,
        title: "Delete the '".concat(title, "' badge permanently?"),
        body: "The '".concat(title, "' badge will be deleted permanently, and the badge will be revoked from all users. Please note that this action can't be reverted."),
        action: (0, _absoluteUrlRuntime.resolveUrl)("Delete permanently"),
        variant: "warning"
      }));
    }
  }]);
  return BadgeOverview;
}(_preact.Component);

var _default = BadgeOverview;
exports.default = _default;